const VariableType = {
	Variable: 'Variable',
	Expression: 'Expression'
};

export default VariableType;
